<template>
  <b-container id="manfacturer">
    <b-row>
      <topbar />
    </b-row>
    <b-row>
      <search />
    </b-row>
    <div>
      <cart-side />
    </div>
    <b-row>
      <app-nav />
    </b-row>
    <b-row class="manfacturer-header" no-gutters>
      <div class="manfacturer-banner" />
      <b-col class="manfacturer-list">
        <div
          v-for="(manufacturer,index) in manufacturers"
          :key="index"
          @click="chooseManufacturer(manufacturer)"
        >
          <manufacturer-info :manufacturer="manufacturer" />
        </div>
      </b-col>
      <b-col cols="12" class="manfacturer-result">筛选:{{ chooseInfo.name }}</b-col>
    </b-row>
    <b-toast id="msg" class="msg" no-close-button variant="danger" static auto-hide-delay="100">
      {{ Msg }}
    </b-toast>
    <b-row class="item-list">
      <b-col v-for="(item,index) in itemList" :key="index" cols="3">
        <manufacturer-item :item="item" @successtocart="successToCart" @showMsg="showMsg" />
      </b-col>
    </b-row>
    <div class="select-page">
      <span class="page-now" @click="firstPage">首页</span>
      <span class="page-now" @click="previousPage">上一页</span>
      <span class="page-now" @click="nextPage">下一页</span>
      <span class="page-now" @click="lastPage">尾页</span>
      <input v-model="pageInfo.index" class="page-now" @blur="loadManufacturerItem">/
      <span class="page-count">{{ pageInfo.pages }}</span>页
    </div>
    <div>
      <app-footer />
    </div>
  </b-container>
</template>

<script>
import CartSide from '../item/CartSide'
import footer from '@/components/Footer.vue'
import topbar from '@/components/TopBar.vue'
import search from '@/components/Search.vue'
import nav from '@/components/Nav.vue'
import manufacturerItem from './ManufacturerItem.vue'
import manufacturerInfo from './ManufacturerInfo.vue'
import { ItemService } from '@/service/ItemService'
import { ManufacturerService } from '@/service/ManufacturerService'
export default {
  components: {
    search, topbar,
    'cart-side': CartSide,
    'manufacturer-info': manufacturerInfo,
    'manufacturer-item': manufacturerItem,
    'app-nav': nav,
    'app-footer': footer
  },
  data () {
    return {
      ItemsIds: [],
      Msg: '',
      itemList: [],
      pageInfo: { count: '', index: 1, pages: '', size: 20 },
      chooseInfo: '',
      manufacturers: []
    }
  },
  mounted () {
    this.getManufacturer()
  },
  methods: {
    successToCart () {
      this.showMsg('添加成功')
    },
    showMsg (msg) {
      this.Msg = msg
      this.$bvToast.show('msg')
    },
    test () {

    },
    getManufacturer () {
      // 请求厂商信息
      this.manufacturers = []
      var data = {
        unionId: this.$store.getters.unionId
      }
      var manufacturerService = new ManufacturerService(this.$axios)
      manufacturerService.loadManufacturer(data).then(res => {
        res.forEach(manufacturer => {
          console.log(manufacturer)
          this.manufacturers.push(manufacturer)
        })
        this.chooseManufacturer(this.manufacturers[0])
      })
    },
    loadManufacturerItem () {
      // 请求商品详情
      this.backTop()
      this.itemList = []
      this.ItemsIds = []
      const data = {
        unionId: this.chooseInfo.unionId,
        manufacturer: this.chooseInfo.name,
        manufacturerId: this.chooseInfo.id,
        index: this.pageInfo.index,
        size: this.pageInfo.size,
        source: 1
      }
      var itemService = new ItemService(this.$axios)
      itemService.loadManufacturerItem(data).then(res => {
        console.log('sdaa++++++', res);
        ({ count: this.pageInfo.count, index: this.pageInfo.index, pages: this.pageInfo.pages, size: this.pageInfo.size } = res.pageInfo)
        res.items.forEach(item => {
          item.showPrice = '加载中'
          if (item.shopName !== null && item.shopName.length > 11) {
            item.shopName = item.shopName.slice(0, 11) + '...'
          }
          if (item.manufacturer !== null && item.manufacturer.length > 19) {
            item.manufacturer = item.manufacturer.slice(0, 19) + '...'
          }
          if (item.standard !== null && item.standard.length > 15) {
            item.standard = item.standard.slice(0, 15) + '...'
          }
          item.num = 1
          this.ItemsIds.push(item.id)
          this.itemList.push(item)
        })
        this.resetItem()
      })
    },
    chooseManufacturer (data) {
      this.chooseInfo = { name: data.name, id: data.id, unionId: data.unionId }
      this.pageInfo = { count: '', index: 1, pages: '', size: 20 }
      this.loadManufacturerItem()
    },
    resetItem () {
      // 重新给商品信息赋值
      console.log('resetItem____')
      var itemService = new ItemService(this.$axios)
      itemService.loadFullInfo(this.ItemsIds).then(res => {
        console.log(res, '++++++++res')
        const itemMap = new Map()
        res.forEach(item => {
          itemMap.set(item.id, item)
        })
        this.itemList.forEach(item => {
          if (item.id === itemMap.get(item.id).id) {
            item.price = itemMap.get(item.id).instructPrice.toFixed(2)
            item.showPrice = '￥' + itemMap.get(item.id).instructPrice.toFixed(2)
          }
        })
      })
    },
    backTop () {
      document.scrollTop = 0
      document.documentElement.scrollTop = 0
      console.log('回到顶部')
    },
    firstPage () {
      if (this.pageInfo.index !== 1) {
        this.pageInfo.index = 1
        this.loadManufacturerItem()
      }
    },
    previousPage () {
      if (this.pageInfo.index !== 1) {
        this.pageInfo.index -= 1
        this.loadManufacturerItem()
      }
    },
    nextPage () {
      if (this.pageInfo.index !== this.pageInfo.pages) {
        this.pageInfo.index += 1
        this.loadManufacturerItem()
      }
    },
    lastPage () {
      if (this.pageInfo.index !== this.pageInfo.pages) {
        this.pageInfo.index = this.pageInfo.pages
        this.loadManufacturerItem()
      }
    }
  }
}
</script>

<style scoped>
#manfacturer{
  text-align: center;
}

.item-list{
  width: 1200px;
margin: 0 auto;
}
.manfacturer-header{
  margin: 10px auto;
  width: 1200px;
  height: 310px;
  border: 1px #000000 solid;
}
.manfacturer-banner{
 background-image:url('../../../static/images/manufacturerBanner1.png');
  width: 160px;
  background-color: blue;
  height: 275px;
}
.msg{
position:fixed;
top:40%;
left: 48%;
}
.manfacturer-list{
  display: flex;
  flex-wrap:wrap;
  height: 275px;
  overflow-y: scroll;
  margin-left: 5px;
}

.manfacturer-result{
    border: 1px solid #dcdcdc;
  background-color: #ffffff;
  line-height: 35px;
  font-size: 16px;
  text-align: left;
  padding-left: 20px;
}
.page-now{
  margin-left: 20px;
  cursor:pointer;
  font-size: 14px;
  line-height: 30px;
    text-align: center;
    display: inline-block;
    height: 30px;
    width: 50px;
    background-color: #ffffff;
  }
.select-page{
  margin-top: 20px
}
.page-count {
    color: #f00;
  }
</style>
